import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  @Input() breadcrumbItems;
  @Input() title: string;
  @Output() pastas = new EventEmitter<number>();

  constructor() { }

  ngOnInit() {
    console.log('init', this.breadcrumbItems)
  }

  listarPastas(item: any) {
    this.pastas.emit(item.cod_pasta_pas);
  }
}
